export const formInitialValues = (data) => ({
  kodeSumberPengadaan: data?.kode_sumber_pengadaan ?? "",
  keterangan: data?.keterangan ?? "",
  namaSumberPengadaan: data?.nama_sumber_pengadaan ?? "",
  idSumberPengadaan: data?.id_sumber_pengadaan ?? "",
});
